import React from "react";

export default function PaySelect({
  elem,
  data,
  typeVisited,
  onChangeData,
  manualDocumentInfo,
}) {
  return (
    <div className="mb-2">
      <label for="nombre">{elem.label}</label>
      <select
        className={`${
          typeVisited ? (data?.entryType ? "" : "formError") : ""
        } selector form-select form-select-sm especialGroup shadow-sm formHover`}
        name={elem.id}
        id={elem.id}
        onChange={(e) => {
          onChangeData(e.target.value, e.target.id);
        }}
      >
        {elem.options.map((elem, index) => {
          return (
            <option
              key={index}
              value={elem?.values}
              selected={
                manualDocumentInfo?.selected &&
                manualDocumentInfo?.selected[0]?.document?.meta?.pago ===
                  elem.values
                  ? true
                  : false
              }
            >
              {elem?.option}
            </option>
          );
        })}
      </select>
    </div>
  );
}
